<script setup>
import { ref, onMounted } from "vue";
import cookies from "browser-cookies";
import { policyUrl } from "@/utils/provider";
import { initYandexMetrika } from "@/utils/metrika";

const COOKIE_NAME = "cookieConsent";
const COOKIE_EXPIRATION_DAYS = 183;

const show = ref(false);

onMounted(() => {
	show.value = cookies.get(COOKIE_NAME);
	
	if (show.value) {
		initYandexMetrika()
	}
});

const acceptCookies = () => {
	cookies.set(COOKIE_NAME, "true", { expires: COOKIE_EXPIRATION_DAYS });
	show.value = true;
    initYandexMetrika()
};
</script>
<template>
	<div class="cookies" v-if="!show">
		<div class="cookies__container">
			<div class="cookies__content">
				<p>
					Мы используем файлы cookie для улучшения вашего опыта на сайте. <br> Продолжая использовать наш сайт, вы соглашаетесь с использованием файлов cookie.

				</p>
				<p>
					Подробнее о нашей  <a target="_blank" :href="policyUrl">политике конфиденциальности</a>
				</p>
			</div>
			<button class="btn cookies__btn --middle" @click="acceptCookies">Согласиться</button>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.cookies {
	position: fixed;
	width: 83rem;
	bottom: 3%;
	left: 50%;
	transform: translateX(-50%);
	padding: 2rem;
	background: var(--white);
	z-index: 3;
	box-shadow: 0 9px 24px 0 rgba(0, 0, 0, 0.2);
	@media (max-width: vars.$t) {
		width: auto;
		left: var(--padding-container);
		right: var(--padding-container);
		transform: translateX(0);
	}
	@media (max-width: vars.$x480) {
	
	}
}
.cookies__container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 2.4rem;
	@media (max-width: vars.$xx) {
		flex-direction: column;
	}
	@media (max-width: vars.$x480) {
		gap: 1.5rem;
	}
}
.cookies__content {
	display: grid;
	gap: 1rem;
	font-size: 1.4rem;
	line-height: 140%;
	color: var(--black);
	@media (max-width: vars.$x480) {
		// font-size: 1.5rem;
	}
	a {
		white-space: nowrap;
		color: var(--red);
		text-decoration: none;
		@media (hover: hover) {
			&:hover {
				text-decoration: underline;
			}
		}
	}
}

.cookies__btn {
	border: 0;
	@media (max-width: vars.$x480) {
		width: 100%;
	}
}
</style>
